import { render, staticRenderFns } from "./DangerIcon.vue?vue&type=template&id=d9b3c64a&scoped=true&"
import script from "./DangerIcon.vue?vue&type=script&lang=js&"
export * from "./DangerIcon.vue?vue&type=script&lang=js&"
import style0 from "./DangerIcon.vue?vue&type=style&index=0&id=d9b3c64a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b3c64a",
  null
  
)

export default component.exports